import { Reducer } from 'redux'
import { ThemeState, ThemeTypes } from './types'

const INITIAL_STATE: ThemeState = {
  isDarkMode: null,
}

const reducer: Reducer<ThemeState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ThemeTypes.SWITCH_COLOR_MODE:
      return { ...state, isDarkMode: action.payload.isDarkMode }
    default:
      return state
  }
}

export default reducer
